// extracted by css-extract-rspack-plugin
export default {"cls1":"MultiPaperModal-cls1_kpF","cls2":"MultiPaperModal-cls2_ZJj MultiPaperModal-cls1_kpF"};